import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { AllDashboardServiceProxy, GetAllProjectDto, LocationEmailReceiverDto, ProjectMemberImagesDto, ProjectServiceProxy } from '../../../../../shared/service-proxies/service-proxies';

@Component({
    selector: 'app-projects-info-section',
    templateUrl: './projects-info-section.component.html',
    styleUrls: ['./projects-info-section.component.css']
})
export class ProjectsInfoSectionComponent extends AppComponentBase implements OnInit {
    projectInfo: GetAllProjectDto[];
    isLoaded = false;
    isEmpty = true;
    istrueValue: boolean;
    viewAllPanelVisible = false;
    locationEmailReceiverDto: ProjectMemberImagesDto[] = [];
    dateTime = new Date();
  
    constructor(private _monitorService:MonitoringService,private _AllDashboardServiceProxy: AllDashboardServiceProxy, 
                private _projectServiceProxy: ProjectServiceProxy, private router: Router, injector: Injector) {super(injector) }



    ngOnInit(): void {
        this.getUserTeamProjectdetails();
    }


    getUserTeamProjectdetails() {
        try{
        this._monitorService.logTrace("UI-getUserTeamProjectdetails",{"getUserTeamProjectdetails ":"getUserTeamProjectdetails: "+this.dateTime})
       //this.istrueValue = this.isGranted('Pages.ShowManager.Dashboard');
        this._AllDashboardServiceProxy.getProjectDetails(false).subscribe(result => {
            this.projectInfo = [];
            result.forEach(x => {

                if (x.projectImage === '') {
                    x.projectImage = 'assets/common/images/projects/default image for project -1.png';
                }
                x.teamProfileImage.forEach(y => {
                    if (y.image === null || y.image === '')
                        y.image = 'assets/common/images/default-profile-picture1.svg';
                    y['userImage'] = y.image;
                    y['userName'] = y.fullName;
                });
                
               
                this.projectInfo.push(x);
                this.isEmpty = false;
            });
            this.isLoaded = true;
           // console.log('Pro', this.projectInfo);
        });

        // this._projectServiceProxy.getProjectMemberImages().subscribe(result => {
        //     this.locationEmailReceiverDto = result;
        // })
    }
    catch(ex:any){
        this._monitorService.logException(ex ,2);
      }
    }

    viewall(){
        this.router.navigate(['app/main/projects-new/projects-new-management']);
    }

    DisableTooltip(name: string, num: number) {
        return name?.length > num ? false : true;
    }

    redirectToViewPage(id: number, projectTypeId: number) {
        this.router.navigate(['/app/main/projects-new/project-details'], { state: { ProjectId: id, option: projectTypeId } });
    }
}
